export default "__VITE_ASSET__CC82jtMm__"